/**
 * /manager-review — v1 with the pilot button until cutover; once the proxy says `live`
 * (MANAGER_REVIEW_V2_LIVE in proxy-server/lib/managerReviewV2.js), v2 for everyone. Rolling back
 * is flipping that flag: v1 is still here.
 */
import { Button } from '@finn-auto/design-system/atoms/button';
import { Spinner } from '@finn-auto/design-system/atoms/spinner';
import ManagerReviewView from './ManagerReviewView';
import ManagerReviewV2View from './ManagerReviewV2View';
import ManagerReviewV2Entry from '../components/manager-review-v2/ManagerReviewV2Entry';
import { useManagerReviewV2Access } from '../components/manager-review-v2/useManagerReviewV2Access';

export default function ManagerReviewRoute() {
  const { live, loading, failed, retry } = useManagerReviewV2Access();
  if (loading) return <div className="flex justify-center p-12"><Spinner /></div>;
  // Not v1 as a guess: after cutover that would save into the retired drafts table.
  if (failed) {
    return (
      <div className="flex flex-col items-center gap-3 p-12 text-sm text-gray-700">
        <p>The Manager Review could not load. Check your connection and try again.</p>
        <Button type="button" variant="outline" size="sm" onClick={retry}>Try again</Button>
      </div>
    );
  }
  if (live) return <ManagerReviewV2View />;
  return <><ManagerReviewView /><ManagerReviewV2Entry /></>;
}
